import React from 'react';

function UserDashboard() {
  return (
    <div>
      <h1>Velkommen til dit User Dashboard</h1>
    </div>
  );
}

export default UserDashboard;
